import {Autocomplete, Box, Button, Grid, Grid2, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Paper, Select, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import TokenError from '../tokenError';
import {
    makeGetRequestToUrl,
    makePostRequestToUrl,
    importCSV,
    parseCSVLine,
    handleImportCSVWithCaseInsensitive,
    processBulkImport
} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import React, { useEffect, useState, useRef } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { Label} from "flowbite-react";
import PhoneInput from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import BlockIcon from '@mui/icons-material/Block';
// import DeleteIcon from '@mui/icons-material/Delete';
import threeDots from '../../assets/images/threeDots.svg';
import BlockImg from '../../assets/images/blockImg.svg';
import deleteImg from '../../assets/images/deleteImg.svg';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import { CSVLink } from "react-csv";
import { useJsApiLoader } from "@react-google-maps/api";
import importArrowIcon from '../../assets/images/importArrow.svg';

var constants = require('../../constant');

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const Client = () => {

    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [rows, setRows] = useState([]);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('tms_client_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage] = useState(10);
    
    const [tokenExpired, setTokenExpired] = useState(false);
    const [openAddClient, setOpenAddClient] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [clientId, setClientId] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [clientName, setClientName] = useState('');
    const fileInputRef = useRef(null);
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [contactPerson, setContactPerson] = useState('');
    const [address, setAddress] = useState('');
    const [countryCode, setCountryCode] = useState('');
    
    // Form validation state
    const [formErrors, setFormErrors] = useState({
        companyName: false,
        clientName: false,
        email: false,
        phone: false,
        address: false,
        contactPerson: false
    });

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmAction, setConfirmAction] = useState(''); // 'block' or 'delete'
    const [actionReason, setActionReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);
    const [allData, setAllData] = useState([]);
    const [locationData, setLocationData] = useState([]);
    const [templateCSV, setTemplateCSV] = useState('');
    const [showTemplateButton, setShowTemplateButton] = useState(false);

    const inputRef = useRef(null); 

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }

    // const { isLoaded, loadError } = useJsApiLoader(loaderOptions);

    const fetchClientData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_clients';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // Sort data in descending order by tms_client_id before setting it
                const sortedData = [...response.data].sort((a, b) => {
                    if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
                    if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
                    return 0;
                });
                setRows(sortedData);
                const formattedData = formatDataForCSV(sortedData);
                setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchTmsLocation = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_locations';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setLocationData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchClientData();
        fetchTmsLocation();
    },[cityFilter])

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item
        }))) : '';
    };

    // Define custom headers
    const headers = [
        { label: 'tms_client_id', key: 'tms_client_id' },
        { label: 'company_name', key: 'company_name' },
        { label: 'tms_client_name', key: 'tms_client_name' },
        { label: 'email', key: 'email' },
        { label: 'phone_no', key: 'phone_no' },
        { label: 'address', key: 'location_name' },
        { label: 'tms_contact_person', key: 'tms_contact_person' }
    ];

    const handleCloseAddClient = () => {
        setOpenAddClient(false);
    };

    const handleSubmit = async() =>{
        // Validate all required fields
        const errors = {
            companyName: !companyName.trim(),
            clientName: !clientName.trim(),
            email: !email.trim() || emailError,
            phone: !phone,
            address: !address,
            contactPerson: !contactPerson.trim()
        };
        
        // Update error state
        setFormErrors(errors);
        
        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            setMessage('Please fill in all required fields correctly');
            showSnackbar(true);
            return; // Prevent form submission
        }
    
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            city_id: cityFilter,
            company_name: companyName,
            country_code: countryCode,
            phone_no: phone,
            email: email,
            location_id: address,
            tms_contact_person: contactPerson,
            tms_client_name: clientName
        };
        if(editMode && clientId!=''){
            payload.tms_client_id = clientId;
        }

        try {
            const url = operationsUrl + '/transport/add_update_client';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenAddClient(false);
                setEditMode(false);
                fetchClientData();

            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

    }

    const handleOpenAddClient = () => {
        setEditMode(false); // Set to "Add" mode=
        setOpenAddClient(true);
        setClientId('');
        setClientName('');
        setCompanyName('');
        setEmail('');
        setPhone('');
        setCountryCode('');
        setAddress('');
        setContactPerson('');
        setFormErrors({
            companyName: false,
            clientName: false,
            email: false,
            phone: false,
            address: false,
            contactPerson: false
        });
        setEmailError(false);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleOpenEditClient = (row) => {
        setEditMode(true);
        setCompanyName(row.company_name);
        setClientId(row.tms_client_id);
        setClientName(row.tms_client_name);
        setEmail(row.email);
        setPhone(row.phone_no);
        setCountryCode(row.country_code);
        setAddress(row.location_id);
        setContactPerson(row.tms_contact_person);
        // Delay setting `openAddDocument` to ensure React processes the previous updates
        setTimeout(() => {
            setOpenAddClient(true);
        }, 0);
    };

    // useEffect(() => {
    //     console.log("Google Maps loaded:", !!window.google?.maps?.places);
    //     const loadAutocomplete = () => {
    //         if (window.google && window.google.maps && window.google.maps.places) {
    //             const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
    //             types: ['geocode'],
    //             // componentRestrictions: { country: 'IN' }, // Optional: Restrict results to a specific country
    //             });

    //             // Add an event listener for when the place is selected
    //             autocomplete.addListener('place_changed', () => {
    //                 const place = autocomplete.getPlace();

    //                 if (place.geometry) {
    //                 // setStopLat(place.geometry.location.lat())
    //                 // setStopLng(place.geometry.location.lng())
    //                 setAddress(place.formatted_address || '')
    //                 }
    //             });
    //         }
    //     };

    //     loadAutocomplete();
    // }, [openAddClient, editMode]);

    const validateEmail = (value) => {
        const re = /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
        return re.test(String(value).toLowerCase());
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(value.length > 0 && !validateEmail(value));
    };

    const handleMenuOpen = (event, row) => {
        setMenuAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const openConfirmDialog = (action, row) => {
        handleMenuClose();
        setConfirmAction(action);
        setSelectedRow(row);
        setActionReason('');
        setIsReasonError(false);
        setConfirmDialogOpen(true);
    };

    const handleConfirmClose = () => {
        setConfirmDialogOpen(false);
        setActionReason('');
        setIsReasonError(false);
    };

    const handleConfirmAction = async () => {
        // Validate reason is provided
        if (!actionReason.trim()) {
            setIsReasonError(true);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const payload = {
                token: token,
                tms_client_id: selectedRow.tms_client_id,
                reason: actionReason
            };
            
            if (confirmAction === 'block') {
                payload.status = 2;
            } else if (confirmAction === 'unblock') {
                payload.status = 1;
            } else if (confirmAction === 'delete') {
                payload.status = 3;
            }

            let url = operationsUrl + '/transport/add_update_client';
            
            const response = await makePostRequestToUrl(url, payload);
            
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchClientData(); // Refresh the list
            } else {
                setMessage(response.message || `Failed to ${confirmAction} client`);
                showSnackbar(true);
            }
        } catch (error) {
            console.error(`Error ${confirmAction}ing client:`, error);
            setMessage(`An error occurred while ${confirmAction}ing the client`);
            showSnackbar(true);
        } finally {
            handleConfirmClose();
        }
    };

    const handleReasonChange = (e) => {
        setActionReason(e.target.value);
        if (e.target.value.trim()) {
            setIsReasonError(false);
        }
    };

    //import CSV
    const requiredColumns = ['company_name', 'tms_client_name', 'email', 'phone_no', 'address', 'tms_contact_person'];
    
    const alternativeColumns = {
        'company_name': ['Company Name', 'company_name', 'COMPANY_NAME', 'Company_Name'],
        'tms_client_name': ['Client Name', 'tms_client_name', 'CLIENT_NAME', 'Client_Name'],
        'email': ['Email', 'email', 'EMAIL', 'Email'],
        'phone_no': ['Phone No', 'phone_no', 'PHONE_NO', 'Phone_No'],
        'tms_contact_person': ['TMS Contact Person', 'tms_contact_person', 'TMS_CONTACT_PERSON', 'Tms_Contact_Person']
    };
    
    // Function to download template CSV file
    const downloadCSVTemplate = () => {
        // Use the required columns with example data
        const headers = ['company_name', 'tms_client_name', 'email', 'phone_no', 'address', 'tms_contact_person'];
        const exampleRow = ['Company ABC', 'Client Name', 'client@example.com', '9876543210', '123 Main Street City', 'Contact Person Name'];
        const csvContent = headers.join(',') + '\n' + exampleRow.join(',');
        
        // Create a blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Clients_Template.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Handle CSV import
    const handleImportCSV = (event) => {
        const file = event.target.files[0];
        if (!file) {
            setMessage('No file selected');
            showSnackbar(true);
            return;
        }
        
        console.log('File selected for import:', file.name, 'Size:', file.size, 'Type:', file.type);
        
        // Use the imported handleImportCSVWithCaseInsensitive function
        handleImportCSVWithCaseInsensitive(
            file,
            // Success callback
            async (data, headers) => {
                try {
                    if (!data || data.length === 0) {
                        setMessage('CSV file contains no data');
                        showSnackbar(true);
                        return;
                    }
                    
                    // Process the import using the new shared function
                    const result = await processLocationImport(data);
                    
                    // Display result message
                    setMessage(result.message);
                    showSnackbar(true);
                    
                    // Refresh data if successful
                    if (result.success) {
                        fetchClientData();
                    }
                    
                    // Reset file input
                    event.target.value = '';
                } catch (error) {
                    console.error('Error processing imported data:', error);
                    setMessage('Error processing imported data');
                    showSnackbar(true);
                    event.target.value = '';
                }
            },
            // Error callback
            (error) => {
                console.error('CSV import error:', error);
                let errorMessage = 'Error importing CSV file';
                
                // If we have specific missing columns info
                if (error.missingColumns) {
                    errorMessage = `CSV is missing required columns: ${error.missingColumns.join(', ')}`;
                    // Show template download button in snackbar
                    setShowTemplateButton(true);
                } else if (typeof error === 'string') {
                    errorMessage = error;
                    setShowTemplateButton(false);
                } else if (error.message) {
                    errorMessage = error.message;
                    setShowTemplateButton(false);
                }
                
                setMessage(errorMessage);
                showSnackbar(true);
                event.target.value = '';
            },
            requiredColumns,
            alternativeColumns
        );
    };
    
    // Process imported location data using the shared processBulkImport function
    const processLocationImport = async (data) => {
        const token = localStorage.getItem('token');
        const url = operationsUrl + '/transport/add_bulk_clients';
        
        // Map function to convert CSV data to the expected API format
        const mapLocationData = (item) => {
            // Create location object from CSV data
            const locationData = {
                city_id: cityFilter,
                company_name: item.company_name || item['Company Name'] || '',
                tms_client_name: item.tms_client_name || item['Client Name'] || '',
                email: item.email || item['Email'] || '',
                phone_no: item.phone_no || item['Phone No'] || '',
                tms_contact_person: item.tms_contact_person || item['TMS Contact Person'] || ''
            };
            
            // Return null for invalid entries (will be filtered out)
            if (!locationData.company_name || !locationData.tms_client_name || !locationData.email || !locationData.phone_no || !locationData.tms_contact_person) {
                console.warn('Skipping invalid client:', item);
                return null;
            }
            
            return locationData;
        };
        
        // Use the shared processBulkImport function
        return await processBulkImport(data, token, url, 'clients', mapLocationData);
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Clients
            </Typography>

            <Grid2 container spacing={2} alignItems="center" style={{ marginTop: '2%', marginBottom: '3%' }}>
                <Grid2 item>
                <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                <Grid2 item>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddClient}
                        style={{
                            width: '185px',
                            height: '50px',
                            backgroundColor: '#000000',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        + Add Client
                    </Button>
                </Grid2>
                <Grid2 item sx={{ marginLeft: "auto", display: 'flex', alignItems: 'center', gap: 2 }}>
                    <input
                        type="file"
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleImportCSV}
                        style={{ display: 'none' }}
                    />
                    <Button
                        variant="outlined"
                        onClick={() => downloadCSVTemplate()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '52px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Sample CSV</span>
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '52px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <img src={importArrowIcon} alt="Import CSV" style={{ width: 20, height: 20, marginRight: 8, marginTop: 2 }} />
                        <span style={{ fontWeight: 500, fontSize: 16 }}>Import CSV</span>
                    </Button>
                        
                    <Button
                        variant="outlined"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1.5px solid #111',
                            background: '#fff',
                            color: '#111',
                            borderRadius: '14px',
                            minWidth: '180px',
                            height: '52px',
                            fontWeight: 500,
                            fontSize: '22px',
                            textTransform: 'none',
                            boxShadow: 'none',
                            transition: 'background 0.2s',
                            '&:hover': {
                                background: '#f9f9f9',
                                borderColor: '#111',
                                color: '#111',
                                boxShadow: 'none',
                            },
                        }}
                    >
                        <CSVLink
                            data={allData}
                            headers={headers}
                            filename={"Client Data.csv"}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                textDecoration: 'none',
                                color: 'inherit',
                                width: '100%',
                                justifyContent: 'center',
                            }}
                        >
                            <span style={{ fontWeight: 500, fontSize: 16 }}>Export CSV</span>
                            <img src={exportCSVIcon} alt="Export CSV" style={{ width: 20, height: 20, marginLeft: 8, marginTop: 2 }} />
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            {/* Sidebar for AddClient */}
            <div
                style={{
                    position: 'fixed',
                    top: 65,
                    right: openAddClient ? 0 : '-100%',
                    height: '100%',
                    width: '50%',
                    backgroundColor: '#f9f9f9',
                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'right 0.3s ease-in-out',
                    zIndex: 1000,
                    overflowY: 'auto',
                    padding: 20
                }}
            >
                <Box onClose={handleCloseAddClient} editMode={editMode}>
                    <div style={{ position: 'relative', padding: '40px 0' }}>
                        {/* Close Button Outside the Card */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseAddClient}
                            style={{
                                position: 'absolute',
                                top: '-15px', // Position it above the Paper component
                                left: '1px',
                                color: '#333',
                                zIndex: 10,
                            }}
                        >
                            <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                        </IconButton>
                        <Paper elevation={3}
                            style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                            <Typography style={{ marginBottom: '20px', fontWeight: '500', fontSize:'24px' }}>
                                {editMode ? 'Edit Client' : 'Add Client'}
                            </Typography>

                            <Grid container spacing={2}>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Company Name<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.companyName && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Company Name is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Enter Company Name" fullWidth variant="outlined"
                                        value={companyName} 
                                        onChange={(e) => {
                                            setCompanyName(e.target.value);
                                            setFormErrors({...formErrors, companyName: !e.target.value.trim()});
                                        }} 
                                        error={formErrors.companyName}
                                        type="text"
                                        InputProps={{
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF'
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Client Name<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.clientName && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Client Name is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Enter Client Name" fullWidth variant="outlined" type="text"
                                        value={clientName} 
                                        onChange={(e) => {
                                            setClientName(e.target.value);
                                            setFormErrors({...formErrors, clientName: !e.target.value.trim()});
                                        }}
                                        error={formErrors.clientName}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>
                                
                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Email<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField sx={{marginTop:'1%'}} placeholder="Email" fullWidth variant="outlined" type="email"
                                        value={email} 
                                        onChange={(e) => {
                                            handleEmailChange(e);
                                            setFormErrors({...formErrors, email: !e.target.value.trim() || emailError});
                                        }}
                                        error={emailError || formErrors.email}
                                        helperText={emailError ? "Please enter a valid email address" : formErrors.email ? "Email is required" : ""}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Mobile Number<span style={{ color: 'red' }}>*</span></Label>
                                    <div style={{width:'100%', marginTop:'1%', border: formErrors.phone ? '1px solid #d32f2f' : '1px solid rgba(0, 0, 0, 0.12)', borderRadius:'12px', backgroundColor:'white'}}>
                                        <PhoneInput
                                            defaultCountry="IN"
                                            value={phone}
                                            onChange={(value) => {
                                                setPhone(value);
                                                setFormErrors({...formErrors, phone: !value});
                                                try {
                                                    const parsed = parsePhoneNumber(value);
                                                    if (parsed) {
                                                        setCountryCode(parsed.countryCallingCode ? `+${parsed.countryCallingCode}` : '');
                                                    }
                                                } catch (err) {
                                                    console.error('Invalid phone number:', err);
                                                    setCountryCode('');
                                                }
                                            }}
                                        placeholder="Enter phone number"
                                        style={{
                                            height: '44px',
                                            marginLeft: '0px', display: 'flex',
                                            alignItems: 'normal', marginTop:'2%'
                                        }}
                                    />
                                    </div>
                                    {formErrors.phone && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Mobile Number is required</Typography>}
                                </Grid>
                                
                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Address<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.address && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Address is required</Typography>}
                                    
                                    {/* <input ref={inputRef} type="text" placeholder=" Search Location" className="filterBtn"
                                        style={{
                                            width:'94%', marginTop:'2%',
                                            backgroundPosition: '8px center',
                                        }}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    /> */}
                                    <Select
                                        sx={{
                                            marginTop: '2%',
                                            height: '50px',
                                            borderRadius:'12px',
                                            backgroundColor: '#FFFFFF',
                                            border: formErrors.address ? '1px solid #d32f2f' : 'none',
                                            '& .MuiSelect-select': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }
                                        }}
                                        fullWidth
                                        value={address}
                                        onChange={(e) => {
                                            setAddress(e.target.value);
                                            setFormErrors({...formErrors, address: !e.target.value});
                                        }}
                                        error={formErrors.address}
                                        displayEmpty
                                    >
                                        <MenuItem value="" disabled>
                                            <Typography sx={{ color: '#666' }}>Select Address</Typography>
                                        </MenuItem>
                                        {locationData.map((location) => (
                                            <MenuItem key={location.location_id} value={location.location_id}>
                                                {location.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Contact Person<span style={{ color: 'red' }}>*</span></Label>
                                    {formErrors.contactPerson && <Typography sx={{ color: '#d32f2f', fontSize: '0.75rem', mt: 0.5 }}>Contact Person is required</Typography>}
                                    <TextField sx={{marginTop:'1%'}} placeholder="Contact Person" fullWidth variant="outlined" type="text"
                                        value={contactPerson} 
                                        onChange={(e) => {
                                            setContactPerson(e.target.value);
                                            setFormErrors({...formErrors, contactPerson: !e.target.value.trim()});
                                        }}
                                        error={formErrors.contactPerson}
                                        InputProps={{
                                            inputProps: { min: 0 }, // Prevent values less than zero
                                            style: {
                                                height: '52px',
                                                borderRadius:'12px',
                                                fontSize: '16px',
                                                padding: '8px 14px',
                                                backgroundColor: '#FFFFFF',
                                            },
                                        }}
                                    />
                                </Grid>

                            </Grid>

                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <Button variant="contained"
                                    onClick={handleSubmit}
                                    sx={{
                                        width: '140px',height: '50px', textTransform: 'none',fontSize: '16px',
                                        backgroundColor: '#0065FF',color: 'white',
                                    }}
                                >
                                    {editMode ? 'Update' : 'Save'}
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleCloseAddClient}
                                    sx={{
                                        width: '140px',height: '50px',textTransform: 'none',
                                        fontSize: '16px',backgroundColor: '#F0F0F0',color: '#B0B0B0'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Paper>

                    </div>
                </Box>
            </div>


            <TableContainer className="table-container">
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'tms_client_id'}
                                    direction={orderBy === 'tms_client_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_client_id')}
                                >
                                    Client ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'company_name'}
                                    direction={orderBy === 'company_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('company_name')}
                                >
                                    Company Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'tms_client_name'}
                                    direction={orderBy === 'tms_client_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_client_name')}
                                >
                                    Client Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'phone_no'}
                                    direction={orderBy === 'phone_no' ? order : 'asc'}
                                    onClick={() => handleRequestSort('phone_no')}
                                >
                                    Phone Number
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'email'}
                                    direction={orderBy === 'email' ? order : 'asc'}
                                    onClick={() => handleRequestSort('email')}
                                >
                                    Email
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'location_name'}
                                    direction={orderBy === 'location_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('location_name')}
                                >
                                    Address
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel
                                    active={orderBy === 'tms_contact_person'}
                                    direction={orderBy === 'tms_contact_person' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_contact_person')}
                                >
                                    Contact Person
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={9} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {(rowsPerPage > 0
                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            : rows
                        ).map((row) => {

                            return(
                                <TableRow key={row.tms_client_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.company_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.phone_no}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.email}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.location_name}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_contact_person}</Typography></TableCell>
                                    <TableCell align="center" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditClient(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}
                                        >
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                        </Button>

                                        <IconButton 
                                            aria-label="more options" 
                                            size="small"
                                            onClick={(e) => handleMenuOpen(e, row)}
                                            sx={{ marginLeft: '4px' }}
                                        >
                                            {/* <MoreVertIcon /> */}
                                            <img src={threeDots} alt="threeDots"/>
                                        </IconButton>
                                        
                                        <Menu
                                            anchorEl={menuAnchorEl}
                                            open={Boolean(menuAnchorEl) && selectedRow?.tms_client_id === row.tms_client_id}
                                            onClose={handleMenuClose}
                                            PaperProps={{
                                                elevation: 3,
                                                sx: {
                                                    borderRadius: '8px',
                                                    minWidth: '160px',
                                                    padding: '4px 0',
                                                    overflow: 'visible',
                                                    '&:before': {
                                                        content: '""',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 14,
                                                        width: 10,
                                                        height: 10,
                                                        bgcolor: 'background.paper',
                                                        transform: 'translateY(-50%) rotate(45deg)',
                                                        zIndex: 0,
                                                    },
                                                },
                                            }}
                                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                        >
                                            <MenuItem onClick={() => openConfirmDialog(row.status === 2 ? 'unblock' : 'block', row)} sx={{ py: 1 }}>
                                            <ListItemText primary={row.status === 2 ? "Unblock" : "Block"} sx={{ color: '#6B7280' }} />
                                                <ListItemIcon>
                                                    <img src={BlockImg} alt="block"/>
                                                </ListItemIcon>
                                            </MenuItem>
                                            <MenuItem onClick={() => openConfirmDialog('delete', row)} sx={{ py: 1 }}>
                                            <ListItemText primary="Delete" sx={{ color: '#6B7280' }} />
                                                <ListItemIcon>
                                                    <img src={deleteImg} alt="delete"/>
                                                </ListItemIcon>
                                            </MenuItem>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                        <button
                            onClick={() => handleChangePage(null, page - 1)}
                            disabled={page === 0}
                            className="pagination-arrow"
                        >
                            <img src={prevIcon} alt="Previous" />
                        </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar 
                open={snackbar} 
                autoHideDuration={showTemplateButton ? 6000 : 2000} 
                onClose={handleSnackbarClose}
                message={message}
                action={showTemplateButton && (
                    <React.Fragment>
                        <Button 
                            color="primary" 
                            size="small" 
                            onClick={downloadCSVTemplate}
                        >
                            DOWNLOAD TEMPLATE
                        </Button>
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleSnackbarClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                )}
            />
            
            {/* Confirmation Dialog for Block/Delete */}
            <Dialog
                open={confirmDialogOpen}
                onClose={handleConfirmClose}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        padding: '8px',
                        maxWidth: '500px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: '600', fontSize: '20px' }}>
                    {confirmAction === 'block' ? 'Block Client' : 
                     confirmAction === 'unblock' ? 'Unblock Client' : 'Delete Client'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description" sx={{ color: '#4B5563', mb: 2 }}>
                        Are you sure you want to {confirmAction} this client? Please provide a reason.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        label="Reason"
                        type="text"
                        fullWidth
                        value={actionReason}
                        onChange={handleReasonChange}
                        error={isReasonError}
                        helperText={isReasonError ? "Please provide a reason" : ""}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                            }
                        }}
                        multiline
                        rows={3}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: '16px' }}>
                    <Button 
                        onClick={handleConfirmClose} 
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: '#F0F0F0', 
                            color: '#6B7280',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { backgroundColor: '#E0E0E0' }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmAction} 
                        autoFocus
                        sx={{ 
                            textTransform: 'none', 
                            backgroundColor: confirmAction === 'delete' ? '#EF4444' : 
                                             confirmAction === 'block' ? '#F59E0B' : '#22C55E',
                            color: 'white',
                            borderRadius: '8px',
                            padding: '8px 16px',
                            '&:hover': { 
                                backgroundColor: confirmAction === 'delete' ? '#DC2626' : 
                                                 confirmAction === 'block' ? '#D97706' : '#16A34A'
                            }
                        }}
                    >
                        {confirmAction === 'block' ? 'Block' : 
                         confirmAction === 'unblock' ? 'Unblock' : 'Delete'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Client;